import * as WordBoard from './wordboard'

import { generatorWords, userWords } from './wordlists'

export type Board = WordBoard.Board
export type BoardPosition = WordBoard.BoardPosition
export type WordDirection = WordBoard.WordDirection
export type BoardWord = WordBoard.BoardWord

export function stripVowels(s:string): string {
    return s.replace(/[aeiou]/g, '');
}

function mapConsonantsToWords(words: string[]): Map<string, string[]> {
    const map = new Map();
    words.forEach((item) => {
        const key = stripVowels(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}

const minConsonantLength = 3;
const maxConsonantLength = 5;
export const fullWordset = new Set(userWords);

const validGeneratorWords = generatorWords.filter(x => {
    let consonants = stripVowels(x).length;
    return consonants >= minConsonantLength && consonants <= maxConsonantLength
})

export const generatorWordSet = new Set(validGeneratorWords);

export const consonantsToWords = mapConsonantsToWords(validGeneratorWords);

export function generateBoard(width: number, height: number): Board {
    return WordBoard.genBoard([...consonantsToWords.keys()], width, height);
}

export function lookupFullWords(voweless: string): string[] {
    return consonantsToWords.get(voweless) || []
}